import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const AlertIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 7.4502C12.5523 7.4502 13 7.89791 13 8.4502V12.4502C13 13.0025 12.5523 13.4502 12 13.4502C11.4477 13.4502 11 13.0025 11 12.4502V8.4502C11 7.89791 11.4477 7.4502 12 7.4502ZM10.9502 15.4502C10.9502 14.8979 11.3979 14.4502 11.9502 14.4502H12.0498C12.6021 14.4502 13.0498 14.8979 13.0498 15.4502V15.5502C13.0498 15.8161 12.9439 16.071 12.7555 16.2587C12.5671 16.4463 12.3118 16.5512 12.0459 16.5502L11.9463 16.5498C11.3955 16.5476 10.9502 16.1006 10.9502 15.5498V15.4502Z'
        fill={color}
      />
    </svg>
  )
})
